import styled from 'styled-components';
import { Tag } from 'antd';
import { Button } from 'shared/theme/elements';

export const StyledTag = styled(Tag)`
  padding: 8px 14px;
  font-size: 14px;
  white-space: break-spaces !important;
  word-break: break-word !important;
  display: flex;
  align-items: center;
  .anticon {
    margin-left: 12px;
  }
`;

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 100%;
  margin-top: -6px;
`;

export const FilterCard = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 12px;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #ececf0;
  border-radius: 10px;

  .__field {
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 132px;
  }

  .__field--search {
    flex: 1;
    min-width: 240px;
  }

  .__field--range {
    width: 260px;
  }

  .__label {
    font-size: 12px;
    font-weight: 500;
    color: #5a5a66;
  }

  .ant-input-affix-wrapper,
  .ant-select:not(.ant-select-customize-input) .ant-select-selector,
  .ant-picker {
    border-radius: 6px;
  }

  .ant-input-suffix {
    color: #9a9aa0;
  }

  .__clear {
    height: 32px;
    padding: 0 16px;
    border: 1px solid #e3e3e8;
    border-radius: 6px;
    background: #fff;
    font-size: 13px;
    font-weight: 600;
    color: #1a1a2e;
    cursor: pointer;
    transition: border-color 0.15s ease, color 0.15s ease;

    &:hover {
      border-color: #1890ff;
      color: #1890ff;
    }
  }
`;

export const TableWrapper = styled.div`
  background: #fff;
  border: 1px solid #ececf0;
  border-radius: 10px;
  overflow: hidden;

  .ant-table-thead > tr > th {
    background: #f7f7f9;
    color: #5a5a66;
    font-size: 12px;
    font-weight: 600;
    padding: 12px 14px;
    white-space: nowrap;
  }

  .ant-table-thead > tr > th::before {
    display: none;
  }

  .ant-table-tbody > tr > td {
    padding: 10px 14px;
    font-size: 13px;
    color: #3a3a46;
    white-space: nowrap;
  }

  .ant-table-pagination.ant-pagination {
    margin: 0;
    padding: 12px 16px;
    border-top: 1px solid #ededf0;
  }

  /* push "1 – 10 of N items" to the far left, page controls stay right */
  .ant-pagination-total-text {
    flex: 1;
    color: #7b7b80;
  }
`;

export const AdTitle = styled.span`
  display: inline-block;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  font-weight: 600;
  color: #1a1a2e;
`;

export const Thumbnail = styled.button<{ $gradient: string; $disabled?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 30px;
  padding: 0;
  border: none;
  border-radius: 4px;
  overflow: hidden;
  background: ${({ $gradient }) => $gradient};
  color: #fff;
  font-size: 10px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.45 : 1)};

  img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .anticon {
    position: relative;
    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.5));
  }
`;

export const DetectionTag = styled.span<{ $manual: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  background: ${({ $manual }) => ($manual ? '#fdf3e3' : '#e6f7ec')};
  color: ${({ $manual }) => ($manual ? '#c77d12' : '#2ca558')};
`;

export const ActionIconButton = styled.button<{ $danger?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 1px solid #e3e3e8;
  border-radius: 6px;
  background: #fff;
  color: ${({ $danger }) => ($danger ? '#ff4d4f' : '#5a5a66')};
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease;

  &:hover {
    border-color: ${({ $danger }) => ($danger ? '#ff4d4f' : '#1890ff')};
    color: ${({ $danger }) => ($danger ? '#ff4d4f' : '#1890ff')};
  }
`;

// Rendered into the global header's action slot, so it's styled on its own rather than via PageWrapper
export const CreateButton = styled(Button)`
  border-radius: 8px;
`;

// Row icon for media without a thumbnail (radio audio)
export const MediaIcon = styled.button<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 30px;
  padding: 0;
  border: 1px solid #e2e8f0;
  border-radius: 5px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 16px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.45 : 1)};
  transition: border-color 0.15s ease, color 0.15s ease;

  &:hover {
    border-color: ${({ $disabled }) => ($disabled ? '#e2e8f0' : '#1890ff')};
    color: ${({ $disabled }) => ($disabled ? '#64748b' : '#1890ff')};
  }
`;
